module.exports = __webpack_public_path__ + "static/media/icon-left.fef2c9b1.svg";